import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import BoltIcon from "@mui/icons-material/Bolt";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SavingsIcon from "@mui/icons-material/Savings";
import ShieldIcon from "@mui/icons-material/Shield";
import BadgeIcon from "@mui/icons-material/Badge";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices";

const benefits = [
  { icon: BoltIcon, title: "Zero", subtitle: "Fuel Expense" },
  { icon: BuildCircleIcon, title: "Zero", subtitle: "Maintenance Cost" },
  { icon: SupportAgentIcon, title: "End to End", subtitle: "Breakdown Support" },
  { icon: SavingsIcon, title: "Minimal", subtitle: "Security Deposite" },
  { icon: ShieldIcon, title: "Free", subtitle: "Insurance Cover" },
  { icon: BadgeIcon, title: "Smart App", subtitle: "Keyless Unlock" },
  { icon: GpsFixedIcon, title: "IoT / GPS", subtitle: "Telematics Tracking" },
  { icon: ElectricalServicesIcon, title: "Swap", subtitle: "Battery Swaping" },
];

export default function WhyGoElectric() {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 11 },
        bgcolor: "background.default",
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: { xs: 5, md: 7 } }}>
          <Box
            sx={{
              display: "inline-block",
              px: 2,
              py: 0.6,
              borderRadius: "20px",
              bgcolor: "rgba(114, 191, 32, 0.12)",
              color: "secondary.dark",
              fontSize: 12.5,
              fontWeight: 700,
              letterSpacing: "0.06em",
              textTransform: "uppercase",
              mb: 1.5,
            }}
          >
            SMART MOBILITY ADVANTAGES
          </Box>
          <Typography
            variant="h3"
            sx={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontSize: { xs: 28, md: 36 },
              fontWeight: 700,
              color: "text.primary",
              letterSpacing: "-0.02em",
            }}
          >
            Why Go Electric{" "}
            <Box component="span" sx={{ color: "primary.main" }}>
              with RideX City
            </Box>
          </Typography>
        </Box>

        <Grid container spacing={{ xs: 3, md: 4 }}>
          {benefits.map((b) => {
            const Icon = b.icon;
            return (
              <Grid item xs={6} sm={4} md={3} key={b.subtitle}>
                <Box
                  sx={{
                    textAlign: "center",
                    p: 3,
                    bgcolor: "background.paper",
                    borderRadius: "16px",
                    border: "1px solid",
                    borderColor: "divider",
                    height: "100%",
                    transition: "transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      borderColor: "primary.main",
                      boxShadow: "0 12px 28px -12px rgba(27, 78, 216, 0.15)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      mx: "auto",
                      mb: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "14px",
                      bgcolor: "rgba(27, 78, 216, 0.08)",
                    }}
                  >
                    <Icon sx={{ fontSize: 28, color: "primary.main" }} />
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: "'Space Grotesk', sans-serif",
                      fontWeight: 700,
                      fontSize: 16,
                      color: "text.primary",
                      lineHeight: 1.25,
                    }}
                  >
                    {b.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "'Space Grotesk', sans-serif",
                      fontWeight: 700,
                      fontSize: 16,
                      color: "text.primary",
                      lineHeight: 1.25,
                    }}
                  >
                    {b.subtitle}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
}
